import Vue from 'vue'
import App from './App'
import router from './router'
// import Router from 'vue-router'
import Vuex from 'vuex'
import './css/elementui.css'
import './css/custom.styl'
import './css/app.styl'
import PageTitle from './components/page-title'
import Crud from './components/crud'
import ModelInputs from './components/model-inputs'
import DetailExtra from './components/detail-extra'
import { flattenArray } from './js/util'
import app from './js/app'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import VueStars from 'vue-stars'

import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  // MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  // RadioButton,
  Checkbox,
  // CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  // OptionGroup,
  Button,
  // ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  // TimeSelect,
  // TimePicker,
  // Popover,
  // Tooltip,
  // Breadcrumb,
  // BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  // Tag,
  Tree,
  // Alert,
  // Slider,
  // Icon,
  Row,
  Col,
  Upload,
  // Progress,
  Badge,
  Card,
  Rate,
  Steps,
  Step,
  Timeline,
  TimelineItem,
  // Carousel,
  // CarouselItem,
  // Collapse,
  // CollapseItem,
  // Cascader,
  // ColorPicker,
  Container,
  Header,
  Aside,
  Main,
  // Footer,
  Loading,
  MessageBox,
  Message,
  Notification,
  Image
} from 'element-ui'



Vue.use(Image)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Autocomplete)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
// Vue.use(MenuItemGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
// Vue.use(RadioButton)
Vue.use(Checkbox)
// Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
// Vue.use(OptionGroup)
Vue.use(Button)
// Vue.use(ButtonGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
// Vue.use(TimeSelect)
// Vue.use(TimePicker)
// Vue.use(Popover)
// Vue.use(Tooltip)
// Vue.use(Breadcrumb)
// Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tabs)
Vue.use(TabPane)
// Vue.use(Tag)
Vue.use(Tree)
// Vue.use(Alert)
// Vue.use(Slider)
// Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Upload)
// Vue.use(Progress)
Vue.use(Badge)
Vue.use(Card)
Vue.use(Rate)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Timeline)
Vue.use(TimelineItem)
// Vue.use(Carousel)
// Vue.use(CarouselItem)
// Vue.use(Collapse)
// Vue.use(CollapseItem)
// Vue.use(Cascader)
// Vue.use(ColorPicker)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
// Vue.use(Footer)
Vue.use(Loading.directive)
// Vue.use(Router)
Vue.use(Vuex)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.component('vue-stars', VueStars)

Vue.config.productionTip = false

Vue.component('page-title', PageTitle)
Vue.component('crud', Crud)
Vue.component('model-inputs', ModelInputs)
Vue.component('detail-extra', DetailExtra)

Vue.use(Viewer, {
  defaultOptions: {
    minWidth: 400,
    minHeight: 200,
    title: false,
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      prev: 1,
      play: {
        show: 1,
        size: 'large',
      },
      next: 1,
      oneToOne: 1,
      reset: 1,
      rotateLeft: 0,
      rotateRight: 0,
      flipHorizontal: 0,
      flipVertical: 0,
    }
  }
})

//把菜单名转成id的映射，用于获取按钮权限
window.menuNameToId = {}

Vue.prototype.$app = app
//每个页面添加按钮权限，暴露当前页面引用
Vue.mixin({
  data() {
    return {btns: []}
  },
  mounted() {
    if(Object.keys(window.menuNameToId).length <= 0){
      if (sessionStorage.loginInfo && JSON.parse(sessionStorage.loginInfo).powersList){
        flattenArray(JSON.parse(sessionStorage.loginInfo).powersList).forEach(m => {
          window.menuNameToId[m.name] = m.id
        })
      }
    }
    if (this.$el.classList && this.$el.classList.contains('page')) { //是页面组件
      //console.log(this.$route.name,this.$el.classList.contains('page'),window.menuNameToId[this.$route.name],Object.keys(window.menuNameToId).length)

      app.getButtons(this.$route.name).then(btns => {
        this.btns = btns
      })
      window.curPage = this
    }
  }
})
/** 状态管理store */
const store = new Vuex.Store({
  state: {
    messageCount: 0,
    allow: true //允许显示新消息提示框
  },
  mutations: {
    setMessageCount(state, count) {
      state.messageCount = count
    },
    setAllow(state, el) {
      state.allow = el
    }
  }
})

/** 请求树资源 */
Vue.prototype.reqLoginTree= function () {
  let toke = sessionStorage.getItem('token'),
      loginInfo = JSON.parse(sessionStorage.loginInfo)
  app.post('loginToken', { token: toke }).then(d => {
    loginInfo.orgList = d.data[0].orgList
    loginInfo.prosList = d.data[0].prosList
    sessionStorage.loginInfo = JSON.stringify(loginInfo)
  })
}

// 注册滚动条加载触发事件v-loadmore绑定
// 直接在 main.js 中引入即可
Vue.directive('loadmore', {
  bind (el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = Math.round(this.scrollHeight - this.scrollTop) <= this.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
})

// 注册
Vue.directive('my-directive', {
  bind: function () {},
  inserted: function () {},
  update: function () {},
  componentUpdated: function () {},
  unbind: function () {}
})

// 注册 (指令函数)
Vue.directive('my-directive', function () {
  // 这里将会被 `bind` 和 `update` 调用
})

// getter，返回已注册的指令
var myDirective = Vue.directive('my-directive')

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store: store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js